{
  "name": "www-momentum",
  "description": "The frontend of WWW.onshape.com",
  "private": true,
  "type": "module",
  "version": "1205.0.4",
  "scripts": {
    "prettier": "pnpm exec prettier --config ./.prettierrc --check \"app/**/*.{vue,ts}\" \"server/**/*.{ts,js}\" nuxt.config.ts",
    "prettier:fix": "pnpm exec prettier --config ./.prettierrc --write \"app/**/*.{vue,ts}\" \"server/**/*.{ts,js}\" nuxt.config.ts",
    "lint": "pnpm exec eslint .",
    "sanity-check": "node ../../build-scripts/sanity-check.cjs",
    "build": "pnpm exec npm-run-all --sequential sanity-check insane:build",
    "insane:build": "nuxt build",
    "sanity-check:dev": "node ../../build-scripts/sanity-check.cjs -m momentum -f dev",
    "dev": "pnpm exec npm-run-all --sequential sanity-check:dev insane:dev",
    "dev:win": "pnpm exec npm-run-all --sequential sanity-check:dev insane:dev:win",
    "reverse-proxy": "cd ./reverse-proxy  && go run . reverse-proxy",
    "insane:dev": "nohup npm run reverse-proxy > reverse-proxy.log 2>&1 & nuxt dev",
    "insane:dev:win": "start /B npm run reverse-proxy > reverse-proxy.log 2>&1 & nuxt dev",
    "generate": "NODE_OPTIONS=--max-old-space-size=6000 pnpm exec npm-run-all --sequential sanity-check insane:generate",
    "insane:generate": "nuxt generate",
    "preview": "nuxt preview",
    "postinstall": "nuxt prepare",
    "pre-push": "pnpm exec npm-run-all --sequential lint prettier nuxt-typecheck build",
    "nuxt-typecheck": "nuxt typecheck"
  },
  "dependencies": {
    "@nuxt/eslint": "1.15.2",
    "@nuxt/image": "2.0.0",
    "@nuxtjs/sanity": "2.0.0",
    "@onshape/www-inertia": "workspace:*",
    "@portabletext/vue": "1.0.14",
    "@sanity/image-url": "2.0.3",
    "@sentry/nuxt": "10.37.0",
    "@vueuse/core": "14.1.0",
    "groq": "5.6.0",
    "gsap": "3.14.2",
    "jsdom": "27.4.0",
    "lodash": "4.18.1",
    "shallowequal": "1.1.0"
  },
  "devDependencies": {
    "@nuxt/devtools": "3.4.2",
    "@nuxt/scripts": "1.3.2",
    "@nuxtjs/tailwindcss": "6.14.0",
    "@onshape/isocomp": "^1.0.118",
    "@sanity/client": "^7.14.1",
    "@sanity/types": "5.6.0",
    "@types/jsdom": "27.0.0",
    "@types/node": "^24.1.0",
    "eslint": "10.2.0",
    "npm-run-all2": "8.0.4",
    "nuxt": "4.5.2",
    "prettier": "3.9.6",
    "prettier-plugin-tailwindcss": "0.7.2",
    "react-is": "19.2.8",
    "sass-embedded": "1.97.3",
    "typescript": "5.9.3",
    "vue-tsc": "~3.2.4"
  },
  "peerDependencies": {
    "httpxy": "*"
  }
}